<template lang="pug">
    #category-posts.category-posts(v-if="section.categories", :class="[spacingTop, spacingBottom]")
        .subfilter(v-if="showFilter && categoryFilters && categoryFilters.length")
            Select.custom-select(
                v-for="filter in categoryFilters"
                :filter="filter"
                v-on:changedFilter="updateCategoryFilter"
                :key="filter.id"
            )
        .vertical(:class="[catLayout, { singlePost : postsPerPage === 1 && showPagination}]")
            .teasers.skeleton(v-if="loading")
                .teaser(v-for="teaser in teasers")
                    .image(:class="{ aspectRatio_21: aspectRatio === '2:1'}")
                        .SkeletonBox
                    .text
                        .title.SkeletonBox
                        .date.SkeletonBox(v-if="showDate")
                        .bait
                            span.SkeletonBox
                            span.SkeletonBox
                            span.SkeletonBox
                            span.SkeletonBox
            .paginated-teasers(v-else)
                .teasers.loaded
                    .teaser(v-for="teaser in teasers")
                        Teaser(:teaser="teaser", :showDate="showDate", :aspectRatio="aspectRatio", :catLayout="catLayout")
            Pagination(
                v-if="pageInfo && showPagination"
                :last-page="pageInfo.lastPage"
                :current-page="pageInfo.currentPage"
                :postPerPage="postsPerPage"
                nav-class="pagination block"
                @change="changePage"
                :loop="loop"
            )
                span.icon(slot="prev")
                    font-awesome-icon(icon="angle-left")
                span.icon(slot="next")
                    font-awesome-icon(icon="angle-right")
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import store from '@/store';
import { get } from '@/helpers';

//import Loading from 'vue-loading-overlay';
import Teaser from './Teaser';
import Select from './Partials/Select'

import Pagination from '@/components/Pagination';

export default {
    name: 'CategoryPosts',
    props: {
        section: {
            type: Object,
            required: true
        },
        perPage: {
            type: Number,
            default: 1
        },
        orientation: {
            type: String,
            default: 'horizontal'
        }
    },
    data() {
        return {
            loading: false,
            currentPage: 1,
            windowWidth: window.innerWidth,
            selectedFilter: {},
            teaserHeight: undefined
        };
    },
    components: {
        //Loading,
        Teaser,
        Select,
        Pagination
    },
    watch: {
        perPage() {
            this.loading = true;
            this.refetch();
        }
    },
    computed: {
        s() {
            return this.sections.findIndex(el => el.id === this.section.id);
        },
        teasers() {
            let teasers = [];
            if (this.loading) {
                if (this.orientation === 'horizontal') teasers = new Array(this.postsPerPage);
                else teasers = new Array(3);
            } else {
                teasers = get(this.section, 'teasers.items');
            }

            return teasers;
        },

        settings() {
            return get(this.section, 'settings');
        },

        showFilter() {
            let showFilter = false;

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'show_filters');
                if (setting && setting.value !== undefined) showFilter = setting.value;
            }

            return showFilter;
        },

        catLayout() {

            let orientation = 'cat_standard';
            if (!this.settings) return orientation;
            const layout = this.settings.find(setting => setting.key === 'layout');
            if (layout) {
                orientation = layout.value;
            }
            return orientation;
        },


        postsPerPage() {
            let perPage = 2;
            if (!this.settings) return perPage;
            const qty = this.settings.find(setting => setting.key === 'postsPerPage');

            perPage = qty.value;

            return perPage;
        },

        showPagination() {
            let pagination = true;
            
            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'show_pagination');
                if (setting && setting.value !== undefined) pagination = setting.value;
            }

            return pagination;
        },

        showDate() {
            let date = true;

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'show_date');
                if (setting && setting.value !== undefined) date = setting.value;
            }

            return date;
        },

        loop() {
            let loop = false;

            if(this.postsPerPage === 1) {
                if (this.section.settings && this.section.settings.length) {
                    const setting = this.section.settings.find(setting => setting.key === 'loop');
                    if (setting && setting.value !== undefined) loop = setting.value;
                }
            }

            return loop;
        },

        scrollToTop() {
            let scrollToTop = true;

            if(this.postsPerPage > 1) {
                if (this.section.settings && this.section.settings.length) {
                    const setting = this.section.settings.find(setting => setting.key === 'scrollToTop');
                    if (setting && setting.value !== undefined) scrollToTop = setting.value;
                }
            } else {
               scrollToTop = false; 
            }

            return scrollToTop;
        },

        pageInfo() {
            return get(this.section, 'teasers.pageInfo');
        },

        style() {
            return {
                width: `calc(${100 / this.perPage}% - 20px)`
            };
        },

        aspectRatio() {
            let aspectRatio = '16:9';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'aspectRatio');
                if (setting && setting.value !== undefined) aspectRatio = setting.value;
            }
            return aspectRatio;
        },
        spacingTop() {
            let spacingTop = 'spacingTopStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingTop');
                if (setting && setting.value !== undefined) spacingTop = setting.value;
            }
            return spacingTop;
        },

        spacingBottom() {
            let spacingBottom = 'spacingBottomStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingBottom');
                if (setting && setting.value !== undefined) spacingBottom = setting.value;
            }
            return spacingBottom;
        },

        ...mapGetters({
            sections: 'sections',
            categoryFilters: 'categoryFilters'
            // cms: 'CMS'
        })
    },
    methods: {
        updateCategoryFilter(payload) {
            if ( payload && payload.value && payload.value !== null && payload.value.length > 0 ) {
                if (Array.isArray(payload.value)) this.selectedFilter[payload.key] = payload.value.join();
                else this.selectedFilter[payload.key] = payload.value;
                 
            }else if ( this.selectedFilter[payload.key] ) delete this.selectedFilter[payload.key]
            this.refetch()
        },
        refetch() {
            this.loading = true;

            const cms = store.getters.CMS.id;
            const tags = this.section.tags.map(tag => tag.id);

            let payload = {
                pageInfo: {
                    currentPage: this.currentPage,
                    perPage: this.postsPerPage
                },
                filters: [
                    {
                        key: 'categories',
                        in: this.section.categories.map(category => category.id)
                    },
                    {
                        key: 'cms',
                        match: cms
                    },
                    {
                        key: 'tags',
                        in: tags
                    }
                ]
            };
            let payload2 = {
                pageInfo: {
                    currentPage: parseInt(this.currentPage),
                    perPage: parseInt(this.postsPerPage)
                },
                filters: [
                    {
                        key: 'section-selection',
                        match: this.section.id
                    },
                    {
                        key: 'in_json',
                        in_json: JSON.stringify(this.selectedFilter)
                    }
                ]
            };
            if(Object.keys(this.selectedFilter).length != 0) payload = payload2;
            this.fetchTeasers(payload)
                .then(teasers => this.insertTeasers({ s: this.s, teasers }))
                .finally(() => (this.loading = false));
        },
        changePage(currentPage) {
            // this.updateTeasersLoading({ s: this.s, value: false })
            this.loading = true;
            this.currentPage = currentPage;
            if(this.scrollToTop) {
                location = '#category-posts';
            }
            this.refetch();
        },
        ...mapMutations({
            updateTeasersLoading: 'updateCategoryPostTeasersLoading',
            insertTeasers: 'insertCategoryPostTeasers'
        }),
        ...mapActions({
            fetchTeasers: 'fetchCategoryPostTeasers'
        })
    },
    mounted() {
        const teasers = { loading: true, pagination: {} };
        this.insertTeasers({ s: this.s, teasers });
        this.refetch();

        window.onresize = () => {
            this.windowWidth = window.innerWidth;
        };

    }
};
</script>

<style lang="sass" scoped>
@import '~@/assets/sass/variables'

.subfilter
    background-color: $color-secondary
    padding: 10px 5px
    margin-bottom: 2.5rem
    display: flex
    justify-content: flex-end
    .multiselect
        max-width: 350px
        margin: 0 5px

.category-posts 
    scroll-margin-top: 50px


.category-posts::v-deep .pagination-container 
    @media (min-width: 767px)
        margin-top: 20px

    .pagination 
        .pagination-previous,
        .pagination-next 
            padding-left: 0.3em
            padding-right: 0.3em

.category-posts .vertical::v-deep .pagination-container
    margin-top: 50px

.paginated-teasers,
.category-posts .vertical   
    @apply relative

.category-posts .vertical.singlePost
    .teasers
        //padding: 0 60px;
        position: relative

    ::v-deep .pagination-container
        position: relative 
        width: 100%
        margin-top: 0      
        @screen md
            position: absolute
            top: 50%
            height: 0
            margin-top: 0
        .nav-btn
            position: relative
            font-size: 1.5rem
            @screen md
                position: absolute
            

        .pagination-prev
            left: 0
            @screen md
                left: -60px

        .pagination-next
            right: 0
            @screen md
                right: -60px

.cat_standard
    .teasers.skeleton .teaser
        display: flex
        flex-direction: row
        .image div
            width: 265px
            height: 265px
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)

        .image.aspectRatio_21
            flex-basis: 369px
            @screen lg
                flex-basis: 497px
            @screen xl
                flex-basis: 570px
            div
                width: 369px
                height: 185px
                @screen lg
                    width: 497px
                    height: 249px
                @screen xl
                    width: 570px
                    height: 285px
        .text
            display: flex
            flex-direction: column
            flex-grow: 1
            margin-left: 2.5rem
            .title.SkeletonBox 
                width: 50%
                height: 30px
                line-height: 1.3
                margin-bottom: 0.6rem
            .date.SkeletonBox
                width: 82px
                height: 16px
            .bait span
                width: 100%
                height: 16px
                margin-bottom: 0.5rem
            .bait
                margin-top: 1.25rem
            .bait span:last-of-type
                width: 60%
                float:left

    .teasers
        text-align: center
        .teaser
            margin-bottom: 2.5rem
            padding-bottom: 1rem
            @screen md
                padding-bottom: 2rem
            @screen lg
                padding-bottom: 2.5rem
            border-bottom: 1px solid #5C5C5B
            &:last-child
                margin-bottom: 10px
                border-bottom: 0px
                padding-bottom: 0

.cat_jobs
    .teasers.skeleton .teaser
        padding: 1.5rem
        .image 
            display: none
        .title.SkeletonBox
            width: 70%
            height: 24px
            margin-bottom: 1rem

        .bait span
            width: 100%
            height: 16px
            margin-bottom: 0.5rem

        .bait span:last-of-type
            width: 60%
            float:left

    .teasers
        display: grid
        grid-template-columns: repeat(1, minmax(0, 1fr))
        gap: 2.5rem
        @screen md
            grid-template-columns: repeat(2, minmax(0, 1fr))
        .teaser
            border: 1px solid #5C5C5B
            background-color: #fff
            color: #5C5C5B
            padding: 0
            margin: 0

.spinner-container
    position: absolute
    width: 100%
    height: 100%
    background: rgba(255, 255, 255, 0.2)

</style>
